import React from "react";


const Man = ({ data }) => {

    return (
        <>
            <div className="lg:flex hidden flex-col bg-no-repeat rounded-3xl bg-right-bottom" style={{ backgroundColor: data.man.bg, backgroundImage: data.man.bg_img_lg }}>

                <div className="flex flex-col font-medium p-10 gap-6 w-[100%]" style={{ color: data.man.txt_color }}>
                    <span className="text-[56px] w-[85%]">{data.man.title}</span>
                    <span className="text-[24px] w-[70%]">{data.man.description}</span>
                </div>

                <a href="https://t.me/ulamanager">
                    <button className=" group relative flex border-solid pl-7 pr-12 py-3 rounded-[30px] items-center gap-2 ml-10 mb-10 mt-32 text-nowrap w-fit bg-white hover:bg-[#1F2225] hover:text-white transition-colors duration-300">
                        <span className="text-[20px] font-normal">{data.man.btn_txt}</span>
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out group-hover:opacity-0 w-6 h-6 p-1.5" src={data.man.arrow_red} alt="?" />
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100 w-6 h-6 p-1.5" src={data.man.arrow_white} alt="?" />

                    </button>
                </a>


            </div>

            <div className="lg:hidden sm:flex hidden flex-col bg-no-repeat rounded-3xl bg-right-bottom" style={{ backgroundColor: data.man.bg, backgroundImage: data.man.bg_img_sm }}>

                <div className="flex flex-col font-medium p-10 gap-6 w-[100%]" style={{ color: data.man.txt_color }}>
                    <span className="text-[48px] w-[82%]">{data.man.title}</span>
                    <span className="text-[20px] w-[60%]">{data.man.description}</span>
                </div>

                <a href="https://t.me/ulamanager">
                    <button className="custom-button group relative flex border-solid pl-7 pr-12 py-3 rounded-[30px] items-center gap-2 ml-10 mb-10 mt-16 text-nowrap w-fit bg-white hover:bg-[#1F2225] hover:text-white">
                        <span className="text-[20px] font-normal">{data.man.btn_txt}</span>
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out group-hover:opacity-0 w-6 h-6 p-1.5" src={data.man.arrow_red} alt="?" />
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100 w-6 h-6 p-1.5" src={data.man.arrow_white} alt="?" />

                    </button>
                </a>


            </div>

            <div className="sm:hidden flex flex-col bg-no-repeat rounded-3xl bg-bottom" style={{ backgroundColor: data.man.bg, backgroundImage: data.man.bg_img_default }}>

                <div className="flex flex-col font-medium p-6 gap-5 w-[100%]" style={{ color: data.man.txt_color }}>
                    <span className="text-[32px] ">{data.man.title}</span>
                    <span className="text-[16px] ">{data.man.description}</span>
                </div>

                <a href="https://t.me/ulamanager">
                    <button className="custom-button group relative flex border-solid pl-7 pr-12 py-3 rounded-[30px] items-center gap-2 ml-6 mb-96 mt-4 text-nowrap w-fit bg-white hover:bg-[#1F2225] hover:text-white">
                        <span className="text-[20px] font-normal">{data.man.btn_txt}</span>
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out group-hover:opacity-0 w-6 h-6 p-1.5" src={data.man.arrow_red} alt="?" />
                        <img className="absolute translate-x-36 transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100 w-6 h-6 p-1.5" src={data.man.arrow_white} alt="?" />

                    </button>
                </a>


            </div>
        </>
    );
};

export default Man;